import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useProjectContext} from '../../models/project-context';
import {Loading} from '../../core/components/loading';
import {consumePostLoginPreferProjectList} from 'src/config/post-login-prefer-project-list';

/**
 * HomeRedirect component handles navigation from the base route '/'
 * For logged-in users:
 * - If project exists in project context, redirect to project details page
 * - If project does not exist, redirect to project list page
 * - Immediately after login/signup, prefer project list even if project_id is stored
 */
export const HomeRedirect = () => {
  const navigate = useNavigate();
  const {projectId, isLoading} = useProjectContext();

  useEffect(() => {
    if (!isLoading) {
      if (consumePostLoginPreferProjectList()) {
        navigate('/project', {replace: true});
        return;
      }
      if (projectId) {
        // Project exists in context, go to project details page
        navigate(`/project/${projectId}`, {replace: true});
      } else {
        // No project in context, go to project list page
        navigate('/project', {replace: true});
      }
    }
  }, [projectId, isLoading, navigate]);

  // Show loading while determining redirect
  return <Loading text="Loading..." />;
};
